import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Button, ModalAdapter, ModalContainer } from '@malirang/front-share';
import { CenterStore } from 'apps/client/src/stores/center/center.store';

@Component({
  selector: 'access-menu-modal',
  templateUrl: './access-menu.modal.html',
  imports: [CommonModule, Button, ModalContainer],
})
export class AccessMenuModal extends ModalAdapter {
  readonly centerStore = inject(CenterStore);
  center = this.centerStore.currentCenter;
}
